import {useNavigate} from "react-router-dom";

export default function UserProfileLink(props) {
    const {id} = props;

    const navigate = useNavigate();

    const onClickHandler = () => {
        return navigate(`/profile/${id}`)
    }

    return <span className="pseudoLink" onClick={onClickHandler}>{id}</span>
}
